import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_SCORE_CARD_RISK_FACTORS } from "../types";
import {
  getScoreCardRiskFactorsFulfilled,
  getScoreCardRiskFactorsPending,
  getScoreCardRiskFactorsRejected,
} from "../actions";
import { sendApiRequest, notifyError, notifyWarning } from "../../../actions";

import generateError from "../../../utilities/generateError";
import { SCORE_CARD_RESULT_MESSAGE } from "../constants/scoreCardsResultMessage";

const createPayload = (payload) => ({
  method: "get",
  url: "scorecard/scorecardriskfactors",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning(SCORE_CARD_RESULT_MESSAGE.NOT_FOUND)
        : getScoreCardRiskFactorsFulfilled(response),
  ],
  onError: [
    getScoreCardRiskFactorsRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getScoreCardRiskFactorsEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_SCORE_CARD_RISK_FACTORS.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(getScoreCardRiskFactorsPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getScoreCardRiskFactorsEpic$;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/getScoreCardRiskFactorsEpic.js